module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-13-6a0f1cdb306df3b48fed7daf5acced6a.jpg";